import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritCustomerAttachedImagesQueryParamsType,
  GetCulpritCustomerAttachedImagesQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerAttachedImages/getCulpritCustomerAttachedImagesQuery.type';

export const getCulpritCustomerAttachedImagesFunction = (
  params: GetCulpritCustomerAttachedImagesQueryParamsType,
): Promise<GetCulpritCustomerAttachedImagesQueryResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/customer/images/additional/vehicle/`,
  );
};
